import { useCallback } from "react";

import { Action, Space } from "types/generated";
import { AccessResult, hasAtLeastOneRequiredAction, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";

const UPDATE_TERRAFORM_PROVIDER_ACCESS_TYPES = [Action.SpaceAdmin, Action.TerraformProviderUpdate];

const useCanUpdateTerraformProvider = (): ((provider?: {
  spaceDetails: Pick<Space, "id" | "accessLevel">;
}) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (provider) => {
      if (!provider) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const hasAccess = hasAtLeastOneRequiredAction(
        UPDATE_TERRAFORM_PROVIDER_ACCESS_TYPES,
        viewer,
        provider.spaceDetails.id
      );

      if (hasAccess) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanUpdateTerraformProvider;
